// ** React Imports
import { Suspense, lazy, Fragment } from 'react'
import { createRoot } from 'react-dom/client'

// ** Redux Imports
import { Provider } from 'react-redux'
import { store } from './redux/storeConfig/store'

// ** styled-components: filter non-DOM props (e.g. minWidth/align leaked by
// react-data-table-component v7) so they don't reach the underlying <div>
import { StyleSheetManager } from 'styled-components'
import isPropValid from '@emotion/is-prop-valid'
const shouldForwardProp = (prop, target) => (typeof target === 'string' ? isPropValid(prop) : true)

// ** CASL & ThemeColors Context
import ability from './configs/acl/ability'
import { ToastContainer, toast } from 'react-toastify'
import { AbilityContext } from './utility/context/Can'
import { ThemeContext } from './utility/context/ThemeColors'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

import Avatar from '@components/avatar'
import { Check } from 'lucide-react'
import axios from 'axios'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

import { attachRetryInterceptor } from './utility/http/retry'
import { handleAxiosError } from './utility/http/errorHandler'

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

const SuccessToast = (props) => (
  <Fragment>
    <div className='toastify-header'>
      <div className='title-wrapper'>
        <Avatar size='sm' color='success' icon={<Check size={12} />} />
        <h6 className='toast-title'>Success!</h6>
      </div>
    </div>
    <div className='toastify-body'>
      <span role='img' aria-label='toast-text'>
        {props.message}
      </span>
    </div>
  </Fragment>
)

axios.defaults.withCredentials = true
axios.defaults.withXSRFToken = true
attachRetryInterceptor(axios)

axios.interceptors.response.use(
  response => {
    if (response.status === 200 && response.data.success) {
      toast.success(<SuccessToast message={response.data.success} />)
    }
    return response
  },
  error => {
    handleAxiosError(error)
    return Promise.reject(error)
  }
)

// window.addEventListener('storage', (e) => {
//   const pathName = window.location.pathname
//   const arr = pathName.split('/')
//   if (e.key === 'userData' && window.location.pathname !== '/login' && arr[1] !== 'ResetPasswordSuccess' && window.location.pathname !== '/firstLogin') {
//     // ** Remove user, accessToken & refreshToken from localStorage
//     localStorage.removeItem('userData')
//     localStorage.removeItem('_grecaptcha')
//     localStorage.removeItem('accessToken')
//     localStorage.removeItem('refreshToken')
//     window.location = '/login/__ua'
//   }
// })

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <Suspense fallback={<Spinner />}>
        <AbilityContext.Provider value={ability}>
          <ThemeContext>
            <LazyApp />
            <ToastContainer icon={false} />
          </ThemeContext>
        </AbilityContext.Provider>
      </Suspense>
    </StyleSheetManager>
  </Provider>
)
